"use strict";

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1 1 auto;\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = require("../../../theme/styled");

var CardImage = styled_1["default"]('div')(_templateObject());
exports["default"] = CardImage;